<div class="pasi-wizard">
  <div #mobile class="d-block d-lg-none">
    <div class="pasi-wizard_steps">
      <div class="pasi-wizard_steps_container">
        <div class="pasi-wizard_steps_container_number">
          <span>{{('SI_NUMBER_OF_NUMBER' | translate: {
                  currentNumber: currentStep + 1, totalNumber:
                  steps.length})}}
          </span>
        </div>
        <div class="pasi-wizard_steps_container_circles">
          <svg width="46" height="46">
            <g class="pasi-wizard_steps_container_circles_g">
              <circle class="pasi-wizard_steps_container_circles_g_circle-background"
                      cx="23" cy="23" r="20" stroke-miterlimit="10"
              ></circle>
              <circle
                class="pasi-wizard_steps_container_circles_g_circle-step step{{currentStep + 1}}-{{steps.length}}"
                cx="23" cy="23" r="20" stroke-miterlimit="10"
              ></circle>
            </g>
          </svg>
        </div>
      </div>
      <div>
        <div class="pasi-wizard_steps_title">
          <span>{{steps[currentStep].name | translate}}</span>
        </div>
        <div class="pasi-wizard_steps_next">
          <ng-container *ngIf="currentStep < steps.length - 1; else lastStep">
            <span class="pasi-wizard_steps_next_label">{{'SI_NEXT' | translate}}:&nbsp;</span>
            <span
              class="pasi-wizard_steps_next_name">{{steps[currentStep + 1].name | translate}}</span>
          </ng-container>
          <ng-template #lastStep>
            <span class="pasi-wizard_steps_next_label">{{'SI_LAST_STEP' | translate}}</span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div #desktop class="d-none d-lg-block">
    <div class="pasi-wizard_steps mb-2">
      <div class="pasi-wizard_steps_step"
           *ngFor="let step of steps; let i = index"
           [class.current-step]="currentStep === i"
           [class.completed-step]="currentStep > i">
        <div class="pasi-wizard_steps_step_number">
          <span>{{i + 1}}</span>
        </div>
        <div>
          <span>{{step.name | translate}}</span>
        </div>
      </div>
    </div>
    <div [hidden]="steps[currentStep].hideTitle" class="pasi-wizard_step mb-2">
      <span>{{steps[currentStep].name | translate}}</span>
    </div>
  </div>
  <div class="pasi-wizard_content mt-2">
    <ng-content></ng-content>
  </div>
</div>
